import styled from "styled-components";

export const RootContainer = styled.div`
	.infinite-scroll-component__outerdiv {
		height: calc(100vh - 110px);
	}

	.infinite-scroll-component {
		height: 100% !important;
		overflow-x: hidden !important;
	}
`;

export const HistoryBox = styled.div`
	display: flex;
	flex-direction: column;
	padding: 16px ;
	gap: 8px;
	background-color: #F8EEFF;
	margin-bottom: 1px;
`;

export const DateAndAmountContainer = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
`;
export const Date = styled.p`
	flex-grow: 1;
	color: #5D5189;
	font-size: 14px;
	font-style: normal;
	font-weight: 400;
	line-height: 15px;
	text-align: left;
`;
export const Amount = styled.p`
	color: #49028E;
	text-align: right;
	font-size: 14px;
	font-style: normal;
	font-weight: 500;
	line-height: 21.49px;
`;

export const ExpireBox = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: start;
	align-items: center;
	gap: 4px;
`;

export const ExpireText = styled.p`
	color: #FE0C37;
	font-size: 14px;
	font-style: normal;
	font-weight: 400;
	line-height: 18.8px;
`;

export const ExpiredTime = styled.p`
	color: #9B92BB;
	font-size: 14px;
	font-style: normal;
	font-weight: 400;
	line-height: 18.8px;
`;

export const SpinWrapper = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	height: ${(props) =>
		props.size === "large" ? "calc(100vh - 110px)" : "auto"};
`;

export const EmptyText = styled.div`
	height: calc(100vh - 110px);
	align-items: center;
	justify-content: center;
	display: flex;
	flex-direction: column;
	gap: 16px;

	font-size: 14px;
	font-style: normal;
	font-weight: 400;
	line-height: normal;
	color: #808080;
`;

export const HistoryWrapper = styled.div`
	border-radius: 16px;
	max-height: 700px;
`;
